import React from "react";

import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";

import { __t } from "../../utils/translate";

type ProductImageProps = {
    className?: string;
    imageData: IGatsbyImageData;
    alt: string;
    loading: "eager" | "lazy";
    decoding?: "async" | "sync";
};

const ProductImage: React.FC<ProductImageProps> = ({
    imageData,
    alt,
    className = "",
    loading,
    decoding = "async"
}) => {
    return (
        <GatsbyImage
            loading={loading}
            decoding={decoding}
            image={imageData}
            className={`${className} w-full`}
            alt={alt}
            sizes="(max-width: 950px) 950px, 950px"
        />
    );
};

export default ProductImage;